export default "__VITE_ASSET__DxSGy6Hf__"